module.exports = __webpack_public_path__ + "img/tmts-about.914ca56e.jpeg";